import { render, staticRenderFns } from "./MailTo.vue?vue&type=template&id=5c8f5c76"
import script from "./MailTo.vue?vue&type=script&lang=ts"
export * from "./MailTo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c8f5c76')) {
      api.createRecord('5c8f5c76', component.options)
    } else {
      api.reload('5c8f5c76', component.options)
    }
    module.hot.accept("./MailTo.vue?vue&type=template&id=5c8f5c76", function () {
      api.rerender('5c8f5c76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/MailTo.vue"
export default component.exports